import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from '@/shared/ui';

import { openTemplateEditor } from '@/entities/templates';

type Props = {
  disabled?: boolean;
  dataComponent?: string;
  onClick: () => void;
};

export const EditTemplateButton: FC<Props> = ({
  disabled,
  dataComponent = 'workspace-template-edit-start',
  onClick,
}) => (
  <Button
    variant="tertiary"
    size="small"
    icon="pen"
    disabled={disabled}
    data-component={dataComponent}
    onClick={onClick}
  >
    <FormattedMessage
      id="workspace.templateEdit.start"
      defaultMessage="Edit template"
    />
  </Button>
);

type OpenProps = {
  seriesId: string;
  disabled?: boolean;
};

// A template's structure is edited only on the Templates page, so a document
// opens its series there, in the edit mode and in a tab of its own.
export const OpenTemplateButton: FC<OpenProps> = ({ seriesId, disabled }) => (
  <EditTemplateButton
    disabled={disabled}
    dataComponent="workspace-template-open"
    onClick={() => openTemplateEditor(seriesId)}
  />
);
